<template>
	<div>
		<div class="signing-top">
			<div class="top">

				<div class="content">
					<h1>{{$t('review-sign.contract.headline') }}</h1>
					<p>{{ getSigningPropertyAddress }}</p>
				</div>
				<a v-if="!isPowerSupplyEnabled" :href="signatureUrl">
					<button class="purple">{{$t('button.continue') }}</button>
				</a>
				<a v-else :href="powerSupplyUrl">
					<button class="purple">{{$t('button.continue') }}</button>
				</a>
			</div>
			<div class="progress-bar">
				<div class="content">
					<div class="col done">
						<div class="dot">
							<svg xmlns="http://www.w3.org/2000/svg"  width="9.895" height="7.38" viewBox="0 0 19.79 14.76">
							  <path class="fill-white" d="M1330.31,1086.51l-10.8,10.8a2.256,2.256,0,0,1-3.02,0l-4.8-4.8a1.994,1.994,0,1,1,2.82-2.82l3.49,3.48,9.49-9.48A1.994,1.994,0,1,1,1330.31,1086.51Z" transform="translate(-1311.12 -1083.12)"/>
							</svg>
						</div>
						<p>{{$t('review-sign.steps.info') }}</p>
					</div>
					<div class="col active">
						<div class="dot"></div>
						<p>{{$t('review-sign.steps.review') }}</p>
					</div>
					<div class="col" v-if="isPowerSupplyEnabled">
						<div class="dot"></div>
						<p>{{$t('review-sign.steps.electricity') }}</p>
					</div>
					<div class="col">
						<div class="dot"></div>
						<p>{{$t('review-sign.steps.sign') }}</p>
					</div>
				</div>
			</div>
		</div>
		<div v-if="!loaded" class="signing-content review">
			<Loader></Loader>
		</div>
		<div v-else class="signing-content review">
			<div class="pdf-viewer">

				<!-- <Loader v-if="loading_pdf" /> -->
				<PdfViewer ref="pdf" :url="pdfUrl" v-on:load="loading_pdf = false;" />

			</div>
			<div class="button-container">
				<a v-if="!isPowerSupplyEnabled" :href="signatureUrl">
					<button class="purple">
						{{ $t('review.continue-to-signature') }}
					</button>
				</a>
				<a v-else :href="powerSupplyUrl">
					<button class="purple">
						{{ $t('button.continue') }}
					</button>
				</a>

				<button class="purple" v-if="showRevokeButton" v-on:click="revokeTenantSignature" :disabled="revoking">
					<span v-if="!revoking">{{ $t('review.revoke') }}</span>
					<span v-if="revoking">{{ $t('loading') }}</span>
				</button>
			</div>
			<div class="zoom-control">
				<div class="control zoom-out">
					<svg xmlns="http://www.w3.org/2000/svg" width="17.985" height="17.985" viewBox="0 0 35.97 35.97">
					  <path class="fill-purple" d="M3648,2057a2,2,0,0,1,0-4h10a2,2,0,0,1,0,4h-10Zm25.39,18.44a2,2,0,0,1-2.78,0l-10.54-10.54a1,1,0,0,1,.1-1.51c6.7-5.75,4.67-17.44-6.11-19.59a5.542,5.542,0,0,0-2.07,0c-13.69,2.73-13.27,20.87,1.25,22.65a3.8,3.8,0,0,0,2.29-.64,2,2,0,1,1,1.55,3.66c-11.03,3.08-22.62-6.98-18.06-20.79a7.149,7.149,0,0,1,1.31-2.33c9.43-11.08,24.06-6.39,27.15,4.63a15.01,15.01,0,0,1-2.52,13.14h-0.01l8.49,8.49A2,2,0,0,1,3673.39,2075.44Z" transform="translate(-3638.03 -2040.03)"/>
					</svg>
				</div>
				<div class="control zoom-in">
					<svg xmlns="http://www.w3.org/2000/svg" width="17.985" height="17.985" viewBox="0 0 35.97 35.97">
					  <path class="fill-purple" d="M3755.39,2075.44a2,2,0,0,1-2.78,0l-10.54-10.54a1,1,0,0,1,.1-1.51c6.7-5.75,4.67-17.44-6.11-19.59a5.542,5.542,0,0,0-2.07,0c-13.69,2.73-13.27,20.87,1.25,22.65a3.8,3.8,0,0,0,2.29-.64,2,2,0,1,1,1.55,3.66c-11.03,3.08-22.62-6.98-18.06-20.79a7.336,7.336,0,0,1,1.31-2.33c9.43-11.08,24.06-6.39,27.15,4.63a15.01,15.01,0,0,1-2.52,13.14h-0.01l8.49,8.49A2,2,0,0,1,3755.39,2075.44ZM3735,2048a2.006,2.006,0,0,1,2,2v3h3a2,2,0,0,1,0,4h-3v3a2,2,0,0,1-4,0v-3h-3a2,2,0,0,1,0-4h3v-3A2.006,2.006,0,0,1,3735,2048Z" transform="translate(-3720.03 -2040.03)"/>
					</svg>
				</div>
			</div>
		</div>


	</div>
</template>
<script>

	import {ROLE_TENANT} from '../../mixins/draft-contract';
    import {store} from "../../store";
    import {mapGetters} from "vuex";
    import Loader from '../../components/Loader.vue';
    import Logo from '../../components/Logo';
    import PdfViewer from '../../components/PdfViewer';

    export default {
        data: () => ({
        	revoking: false,
        	loaded: false,
        	showRevokeButton: false,
			loading_pdf: true,
			role_id: 2,
        }),
        components: {
        	Logo,
        	Loader,
        	PdfViewer,
        },
        computed: {
        	...mapGetters([
        		'getSigningPropertyAddress',
        		'getToken',
                'getSingleDraftContract',
                'isPowerSupplyEnabled'
        	]),
        	signatureUrl() {
        		var review = this.$route.params.review;
        		return '/signing/' + this.$route.params.id + (typeof review != 'undefined' ? '?review=1' : '' );
        	},
        	pdfUrl() {
        		return window.config.apiUrl + 'api/contract/' + this.$route.params.id + '?token=' + this.getToken;
        	},
        	powerSupplyUrl() {
        		return '/signing-el/' + this.$route.params.id;
         	}
        },
        methods: {
        	revokeTenantSignature() {
        		if (!confirm('Are you sure?')) {
        			return;
        		}
        		this.revoking = true;
        		var self = this;
	        	axios({
	        		method: 'POST',
	        		url: window.config.apiUrl + 'api/draft-contract/' + this.$route.params.id + '/revoke',
					cancelToken: window.AuthorizationCancelSource.token,
	        	}).then(response => {
	        		self.$router.push('/contracts/digital-contract/edit/' + self.$route.params.id);
	        	}).finally(e => {
	        		this.revoking = false;
	        	});
        	},
        	seen() {
        		axios({
	        		method: 'POST',
	        		url: window.config.apiUrl + 'api/digital-contract/' + this.$route.params.id + '/signing-review-seen',
					cancelToken: window.AuthorizationCancelSource.token,
	        	});
        	},
	        pdf() {
	        	setTimeout(() => {
	        		this.$refs.pdf.load();
	        	}, 100);
	        },
        },
        created() {
        	if (this.isLandlord) {
	        	axios({
	        		method: 'GET',
	        		url: window.config.apiUrl + 'api/draft-contract/' + this.$route.params.id + '/approval-status',
					cancelToken: window.AuthorizationCancelSource.token,
	        	}).then(response => {
	        		if (response.data.notAllowed) {
	        			this.$router.push('/contracts/digital-contract/status/' + this.$route.params.id);
	        		} else {
		        		this.showRevokeButton = response.data.userCanRevoke;
		        		var bank = response.data.bank;
		        		this.loaded = true;
		        		if (!bank.regNo || !bank.accountNo || !bank.name) {
		        			this.$router.push('/screening-info/'+this.$route.params.id);
		        		}
		        		this.pdf();
		        	}
	        	});
	        } else {
	        	this.loaded = true;
	        	this.pdf();
	        }

        	this.$store.dispatch('fetchContractForSignature', this.$route.params.id);

        	this.seen();
        },
    }

</script>
<style></style>
